module.exports = __webpack_public_path__ + "img/3.9bfd2bd8.png";